import { withFormik } from 'formik'
import { useState } from 'react'
import { compose } from 'ramda'
import moment from 'moment'

import { withGraphModalActions } from '~/hoc/withGraphModalActions'

import CookieModalView from './CookieModalView'

import { hasWindow } from '~/utils/helpers'
import { setCookies } from '~/utils/cookie'

import config from '~/config'

export const CONTENT = {
  GENERAL: 'general',
  DETAILS: 'details'
}

const handleSubmit = (values, { props }) => {
  if (values.marketing && config().enableAnalytics && hasWindow() && window.dataLayer) {
    window.dataLayer.push({ 'event': 'consent_given' })
    window.dataLayer.push({ 'cookie_consent': 'true' })
  }
  setCookies('cookieConsent2', true, null, { expires: moment().add(10, 'years').toDate() })
  props.closeThisModal()
}

const CookieModalContainer = ({ privacyPolicyId }) => {
  const [content, setContent] = useState(CONTENT.GENERAL)

  return (
    <CookieModalView
      content={content}
      setContent={setContent}
      privacyPolicyId={privacyPolicyId}
    />
  )
}

export default compose(
  withGraphModalActions,
  withFormik({
    name: 'cookie-consent',
    mapPropsToValues: () => ({
      marketing: true,
      functional: true,
    }),
    handleSubmit
  })
)(CookieModalContainer)
